import React from 'react'

export default function Image(props) {
    return (
        <a className="main-logo p-3 d-flex align-items-center" href="#">
            <img src="assets/img/brand/skin-n-logo.jpg" title="Skin & You Clinic" alt="Skin & You Clinic"/>
        </a>
    );
}